


class ReviewSection extends HTMLElement {
    constructor() {
        super();
        this.slider = this.querySelector('[id^="Review-section-"]');
        this.next = this.querySelector('[id^="button-next-"]');
        this.prev = this.querySelector('[id^="button-prev-"]');

        if (!this.slider) return;
        this.initPages();
    }
    initPages() {
        var swiper = new Swiper(this.slider, {
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            navigation: {
                enabled: true,
                nextEl: this.next,
                prevEl: this.prev
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true,
            },
            breakpoints: {
                750: {
                    slidesPerView: 3,
                    spaceBetween: 24
                },
                1366: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                }
            },

        });
    }

}
customElements.define('review-section', ReviewSection);



console.log("Review Section");
